export const MicroToolRoutesConfig = {
  productLevelAnalytics: "/product-level-analytics",
  scenarioPage: "/product-level-analytics/scenario/:id",
};
